/**
 * getSubscriptionApi.js
 *
 * Provides an API call to fetch details of a single subscription.
 * Used in self-care to display subscription information.
 *
 * Exports:
 * - getSubscription: Fetches details for a specific subscription.
 */

import { postWithData } from "../shared/apiPatterns";

/**
 * Fetches details for a specific subscription.
 *
 * @param {Object} payload - The request payload containing subscription identifiers.
 * @returns {Promise<Object|null>} The API response JSON containing subscription details, or null on error.
 */
export const getSubscription = (payload) =>
  postWithData("/get-subscription", { ...payload });
